import { contentfulImageSchema } from '@ecomm/contentful-components'
import { documentSchema } from '@ecomm/contentful-schemas'
import { gatsbyImageSchema } from '@ecomm/contentful-schemas'
import { quoteWizardSchema } from '@ecomm/shared-components/data/QuizBanner/quoteWizardSchema'
import { affirmBannerSchema } from '@ecomm/shared-components/lib/AffirmBanner/schema'
import { iconTypes } from '@ecomm/shared-icons'
import { type TypeOf, z } from '@simplisafe/ewok'

const listItemSchema = z.object({
  icon: z.enum(iconTypes),
  headline: z.string(),
  mobileHeadline: z.string().optional(),
  body: z.string().optional(),
  disclaimer: z.string().optional(),
  showBodyInMobile: z.boolean().optional()
})

const confidenceBarSchema = z.object({
  content: z.object({
    listItems: z.array(listItemSchema)
  })
})

const seoSchema = z.object({
  metaKeywords: z.string().array().nullish(),
  metaTitle: z.string(),
  isNoindex: z.boolean(),
  isNofollow: z.boolean(),
  canonicalLink: z.string(),
  metaDescription: z.object({
    metaDescription: z.string()
  })
})

export const benefitsTextSchema = z.object({
  text: z.object({
    json: documentSchema
  })
})

export type BenefitsText = TypeOf<typeof benefitsTextSchema>

export const benefitsSchema = z.object({
  images: z.array(contentfulImageSchema),
  text: benefitsTextSchema
})

export type BenefitsSchema = TypeOf<typeof benefitsSchema>

export const cityStatePageSchema = z.object({
  quoteWizard: quoteWizardSchema
})

export type SeoSchema = Zod.infer<typeof seoSchema>

export const locationPageSchema = z.object({
  confidenceBar: confidenceBarSchema,
  quoteWizard: quoteWizardSchema
})
